import api from './client';
import type { TrackerDomain } from './tracker-types';

export const getDomains = () => api.get<TrackerDomain[]>('/admin/tracker/domains');
export const getDomain = (id: string) => api.get<TrackerDomain>(`/admin/tracker/domains/${id}`);
export const createDomain = (hostname: string) => api.post<TrackerDomain>('/admin/tracker/domains', { hostname });
export const refreshDomain = (id: string) => api.post<TrackerDomain>(`/admin/tracker/domains/${id}/refresh`);
export const deleteDomain = (id: string) => api.delete<{ message: string }>(`/admin/tracker/domains/${id}`);
